<template>
  <nav class="top-bar">
    <button class="hamburger" @click="menuOpen = !menuOpen" aria-label="Menu">
      <span></span>
      <span></span>
      <span></span>
    </button>
    <div class="nav-links" :class="{ open: menuOpen }">
      <router-link to="/" @click="menuOpen = false">Home</router-link>
      <router-link to="/direction" @click="menuOpen = false">Direcção</router-link>
      <router-link to="/dojos" @click="menuOpen = false">Dojos</router-link>
      <router-link to="/contacts" @click="menuOpen = false">Contactos</router-link>
      <router-link to="/redes-sociais" @click="menuOpen = false">Redes Sociais</router-link>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'TopBar',
  data() {
    return {
      menuOpen: false,
    };
  },
};
</script>

<style scoped>
.top-bar {
  width: 100%;
  box-sizing: border-box;
  background: #222;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  position: sticky;
  top: 0;
  z-index: 100;
  padding: 0;
}
.hamburger {
  display: none;
  flex-direction: column;
  gap: 5px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 1rem 1.2rem;
  position: absolute;
  left: 0;
  top: 0;
}
.hamburger span {
  display: block;
  width: 24px;
  height: 3px;
  background: #fff;
  border-radius: 2px;
  transition: 0.3s;
}
.nav-links {
  display: flex;
  gap: 2rem;
  padding: 1rem 2rem;
  align-items: center;
  justify-content: center;
}
.nav-links a {
  color: #fff;
  text-decoration: none;
  font-weight: bold;
  transition: color 0.2s;
}
.nav-links a.router-link-exact-active {
  color: #e53935;
}
.nav-links a:hover {
  color: #e53935;
}

/* Tablet */
@media (max-width: 768px) {
  .top-bar {
    flex-direction: column;
    align-items: stretch;
  }
  .hamburger {
    display: flex;
    position: relative;
    padding: 1rem 1.2rem;
    align-self: flex-start;
  }
  .nav-links {
    display: none;
    flex-direction: column;
    width: 100%;
    background: #222;
    padding: 0;
    gap: 0;
  }
  .nav-links.open {
    display: flex;
  }
  .nav-links a {
    padding: 0.8rem 1.5rem;
    width: 100%;
    text-align: center;
    border-bottom: 1px solid #333;
  }
  .nav-links a:last-child {
    border-bottom: none;
  }
}
</style>
